import http from "plugins/axios";

export default {
  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: `/ta/admin/deal-history/head-inch/list`,
      data
    });
  },
  sendCoin(data) {
    return http.post({
      url: `/ta/admin/send/coin/sendCoin`,
      data
    });
  },
  // sendCoin({ amount, userId }) {
  //   return http.get({
  //     url: `/ta/admin/send/coin/sendCoin?amount=${amount}&userId=${userId}`,
  //   });
  // },

  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    });
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate, spotRate }) {
    const params = [
      `channelId=${channelId}`,
      `userId=${userId}`,
      `rate=${rate}`,
    ];
    if (spotRate !== undefined && spotRate !== "" && spotRate !== null) {
      params.push(`spotRate=${spotRate}`);
    }
    return http.post({
      url: `/channel/partner/rebateRate?${params.join("&")}`,
    });
  },
};
